import IBreadcrumb from "~/interfaces/breadcrumbInterfaces";

export default function (initialBreadcrumbs: Array<IBreadcrumb> = []) {
  return {
    namespaced: true,
    state: {
      breadcrumbs: initialBreadcrumbs,
      history: []
    },
    mutations: {
      push(state, {breadcrumb}) {
        if (state.breadcrumbs.length === 0 || (state.breadcrumbs.length && state.breadcrumbs.slice(-1).pop().url !== breadcrumb.url)) {
          state.breadcrumbs.push(breadcrumb)
        }
      },
      pop(state, {count}) {
        for (let i=0; i < count; i++) {
          state.history.push(state.breadcrumbs.pop());
        }
      }
    },
    actions: {
      push({commit, state}, {breadcrumb}) {
        commit('push', {breadcrumb});
      },
      pop({commit, state}, {count}) {
        commit('pop', {count});
      }
    }
  };
}